import React, {useEffect, useRef, useState} from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import importacaoHistoricoStyle from "assets/jss/material-dashboard-pro-react/views/importacaoHistoricoStyle.jsx";
import ReactTable from "../../components/ReactTableWrapper";
import CardBody from "../../components/Card/CardBody";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle, faExclamationCircle, faExclamationTriangle, faEye, faEyeSlash, faFileExport, faSpinner, faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import connection from "../../connection";
import general from "../../general";
import SweetAlert from "../../components/SweetAlertWrapper";
import Tooltip from "@material-ui/core/Tooltip";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import {infoColor} from "../../assets/jss/material-dashboard-pro-react";
import NavPills from "../../components/NavPills/NavPills";
import Sort from "@material-ui/icons/Sort";
import DoneAll from "@material-ui/icons/DoneAll";
import {Link} from "react-router-dom";

const ImportacaoHistoricoDetalhe = (props) => {
  const {classes} = props;

  const [importacao, setImportacao] = useState(null);
  const [modal, setModal] = useState(null);
  const confirmacoes = useRef([]);

  const [apenasAvisosErros, setApenasAvisosErros] = useState(false);

  const [simulacaoAtiva, setSimulacaoAtiva] = useState(false);
  const [execucaoAtiva, setExecucaoAtiva] = useState(false);
  const request = useRef(false);

  useEffect(() => {
    connection.get('administracao/importacao_historico/' + props.match.params.id + "/detalhes").then(setImportacao)
  }, []);

  useEffect(() => {
    window.validarTodos = () => {
      function push(lista) {
        confirmacoes.current.push(...lista.filter(o => o.resultado.codigo === "AVISO").map(o => o.resultado.avisos.map(a => a.token_confirmacao)).flat());
      }

      push(importacao.ensaio.cursos);
      push(importacao.ensaio.participacoes);
      push(importacao.ensaio.participantes_modulos);

      console.log(confirmacoes.current)
    }
  }, [importacao]);

  const executar = () => {
    if (request.current) return;
    request.current = true;
    setExecucaoAtiva(true);

    let ignorarErros = false;

    setModal(<SweetAlert
      warning
      title="Executar Importação"
      onConfirm={async () => {
        try {
          setModal(null)
          await connection.post("administracao/importacao_historico/" + importacao.id + "/executar", {confirmacoes: confirmacoes.current, saltar_erros: ignorarErros}, null, null, {returnError: true});
          general.success("A importação foi executada", "Sucesso");
          setApenasAvisosErros(false);
          connection.get('administracao/importacao_historico/' + importacao.id + "/detalhes").then(setImportacao)
        } catch (e) {
          console.log(e)
          general.error(e.mensagem)
        }
        request.current = false;
        setExecucaoAtiva(false);
      }}
      onCancel={() => {
        setModal(null);
        request.current = false;
        setExecucaoAtiva(false);
      }}
      confirmBtnCssClass={
        classes.button + " " + classes.danger
      }
      cancelBtnCssClass={
        classes.button
      }
      confirmBtnText="Executar"
      cancelBtnText="Cancelar"
      showCancel
    >
      Tem a certeza que quer executar a importação? Se desejar poderá indicar que os registos com erro devem ser ignorados, podendo ser feita uma exportação dos registos com erro para posterior correção e nova importação.
      <label style={{display: "block", height: 35}}>
        <Checkbox
          defaultChecked={ignorarErros}
          tabIndex={-1}
          onClick={() => {
            ignorarErros = !ignorarErros;
          }}
          checkedIcon={<Check className={classes.checkedIcon}/>}
          icon={<Check className={classes.uncheckedIcon}/>}
          classes={{
            checked: classes.checked
          }}
        />
        Ignorar registos com erro
      </label>
    </SweetAlert>)
  }

  const Tabelas = ({tipo}) => {
    let cursos = importacao[tipo].cursos;
    let participacoes = importacao[tipo].participacoes;
    let participantes_modulos = importacao[tipo].participantes_modulos;

    if (apenasAvisosErros) {
      cursos = cursos.filter(c => c.resultado.codigo !== "OK");
      participacoes = participacoes.filter(p => p.resultado.codigo !== "OK");
      participantes_modulos = participantes_modulos.filter(p => p.resultado.codigo !== "OK");
    }

    let codigo_modelo = cursos.filter(c => c.entrada['CÓDIGO MODELO']);

    let colunas = [
      {
        Header: "Código",
        Cell: ({original: {entrada, resultado}}) => <>
          <Tooltip
            title={resultado.mensagem || "Clique na seta para ver os avisos"}
            placement="top"
            classes={{tooltip: classes.tooltip}}
          >
            <span>{icons[resultado.codigo]}</span>
          </Tooltip> {entrada["CÓDIGO CURSO"]}
        </>,
        width: 150
      }
    ];

    if (codigo_modelo.length > 0) {
      colunas.push({
        Header: "Modelo",
        Cell: ({original: {entrada}}) => entrada["CÓDIGO MODELO"],
        width: 95
      })
    } else {
      colunas.push({
        Header: "Tipo",
        Cell: ({original: {entrada}}) => entrada["TIPO CURSO"],
        width: 80
      })
    }

    colunas.push({
        Header: "Região / Núcleo",
        Cell: ({original: {entrada}}) => entrada["REGIÃO"] + " / " + entrada["NÚCLEO"],
        width: 180
      },
      {
        Header: "Diretor",
        Cell: ({original: {entrada}}) => entrada["NIN DIRETOR"],
        width: 200
      },
      {
        Header: "OSR / OSN",
        Cell: ({original: {entrada}}) => entrada["OSR / OSN"]
      },
      {
        Header: "Data OSR / OSN",
        Cell: ({original: {entrada}}) => general.Renderers.dateRenderer(new Date(Math.round((entrada['DATA OSR / OSN'] - 25569) * 86400 * 1000)), {hide_timezone: true, default: "-"})
      },
      {
        Header: "Data de Início / Fim ",
        width: 300,
        Cell: ({original: {entrada}}) => <>
          {general.Renderers.dateRenderer(new Date(Math.round((entrada['DATA INICIO'] - 25569) * 86400 * 1000)), {hide_timezone: true})} /
          {general.Renderers.dateRenderer(new Date(Math.round((entrada['DATA FIM'] - 25569) * 86400 * 1000)), {hide_timezone: true})}
        </>
      })

    return <>
      <Card>
        <CardHeader color="primary">
          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h4 style={{flex: 1}}>Cursos</h4>
            <Button
              className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
              onClick={() => setApenasAvisosErros(!apenasAvisosErros)}
              color="success">
              <FontAwesomeIcon icon={apenasAvisosErros ? faEye : faEyeSlash}/> {apenasAvisosErros ? "Mostrar todos" : "Mostrar apenas erros e avisos"}
            </Button>
          </div>
        </CardHeader>
        <ReactTable
          placeholder={"Sem cursos para importar"}
          data={cursos}
          minRows={1}
          columns={colunas}
          defaultPageSize={Math.min(cursos.length, 300)}
          showPaginationBottom={true}
          className="-striped -highlight"
          defaultExpanded={cursos.reduce((acc, {resultado}, idx) => ({...acc, [idx]: resultado.codigo === 'AVISO'}), {})}
          SubComponent={props => <DetalhesImportacao {...props} classes={classes} confirmacoes={confirmacoes}/>}
        />
      </Card>
      <Card>
        <CardHeader color="primary">
          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h4 style={{flex: 1}}>Participações em cursos</h4>
            <Button
              className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
              onClick={() => setApenasAvisosErros(!apenasAvisosErros)}
              color="success">
              <FontAwesomeIcon icon={apenasAvisosErros ? faEye : faEyeSlash}/> {apenasAvisosErros ? "Mostrar todos" : "Mostrar apenas erros e avisos"}
            </Button>
          </div>
        </CardHeader>
        <ReactTable
          placeholder={"Sem cursos para importar"}
          data={participacoes}
          minRows={1}
          columns={[
            {
              Header: "Nome",
              Cell: ({original: {entrada, resultado}}) => <>
                <Tooltip
                  title={resultado.mensagem || "Clique na seta para ver os avisos"}
                  placement="top"
                  classes={{tooltip: classes.tooltip}}
                >
                  <span>{icons[resultado.codigo]}</span>
                </Tooltip> {entrada["NOME"]}
              </>
            },
            {
              Header: "Curso",
              Cell: ({original: {entrada}}) => <>{entrada["CÓDIGO CURSO"]}</>,
              width: 150
            },
            {
              Header: "NIN",
              Cell: ({original: {entrada}}) => <>{entrada["NIN"]}</>,
              width: 150
            },
            {
              Header: "Região / Núcleo / Agrupamento",
              Cell: ({original: {entrada}}) => entrada["REGIÃO"] + " / " + entrada["NÚCLEO"] + " / " + entrada["#AGR"],
              width: 210
            },
            {
              Header: "Qualificação",
              Cell: ({original: {entrada}}) => entrada["QUALIFICAÇÃO"],
              width: 150
            }
          ]}
          defaultPageSize={Math.min(participacoes.length, 300)}
          showPaginationBottom={true}
          className="-striped -highlight"
          defaultExpanded={participacoes.reduce((acc, {resultado}, idx) => ({...acc, [idx]: resultado.codigo === 'AVISO'}), {})}
          SubComponent={props => <DetalhesImportacao {...props} classes={classes} confirmacoes={confirmacoes}/>}
        />
      </Card>
      {participantes_modulos && <Card>
        <CardHeader color="primary">
          <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <h4 style={{flex: 1}}>Participações em módulos</h4>
            <Button
              className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
              onClick={() => setApenasAvisosErros(!apenasAvisosErros)}
              color="success">
              <FontAwesomeIcon icon={apenasAvisosErros ? faEye : faEyeSlash}/> {apenasAvisosErros ? "Mostrar todos" : "Mostrar apenas erros e avisos"}
            </Button>
          </div>
        </CardHeader>
        <ReactTable
          placeholder={"Sem cursos para importar"}
          data={participantes_modulos}
          minRows={1}
          columns={[
            {
              Header: "Nome",
              Cell: ({original: {entrada, resultado}}) => <>
                <Tooltip
                  title={resultado.mensagem || "Clique na seta para ver os avisos"}
                  placement="top"
                  classes={{tooltip: classes.tooltip}}
                >
                  <span>{icons[resultado.codigo]}</span>
                </Tooltip> {entrada["NOME PARTICIPANTE"]}
              </>
            },
            {
              Header: "Módulo",
              Cell: ({original: {entrada}}) => <>{entrada["CÓDIGO MODULO"]}</>,
              width: 150
            },
            {
              Header: "Curso",
              Cell: ({original: {entrada}}) => <>{entrada["CÓDIGO CURSO"]}</>,
              width: 150
            },
            {
              Header: "NIN",
              Cell: ({original: {entrada}}) => <>{entrada["NIN PARTICIPANTE"]}</>,
              width: 150
            },
            {
              Header: "Presente",
              Cell: ({original: {entrada}}) => entrada["PRESENTE"],
              width: 150
            },
            {
              Header: "Avaliação",
              Cell: ({original: {entrada}}) => entrada["AVALIACAO"],
              width: 150
            }
          ]}
          defaultPageSize={Math.min(participantes_modulos.length, 300)}
          showPaginationBottom={true}
          className="-striped -highlight"
          defaultExpanded={participantes_modulos.reduce((acc, {resultado}, idx) => ({...acc, [idx]: resultado.codigo === 'AVISO'}), {})}
          SubComponent={props => <DetalhesImportacao {...props} classes={classes} confirmacoes={confirmacoes}/>}
        />
      </Card>}
    </>
  }

  let tabelas_ensaio = React.useMemo(() => <Tabelas tipo={"ensaio"}/>, [importacao, apenasAvisosErros]);

  if (!importacao)
    return null;

  let icons = {
    OK: <FontAwesomeIcon icon={faCheckCircle} color={"#16924a"}/>,
    SALTAR: <FontAwesomeIcon icon={faCheckCircle} color={"#6a93a2"}/>,
    AVISO: <FontAwesomeIcon icon={faExclamationTriangle} color={"#fd9729"}/>,
    ERRO: <FontAwesomeIcon icon={faTimesCircle} color={"#bb0000"}/>,
    CRITICO: <FontAwesomeIcon icon={faExclamationCircle} color={"#ff0606"}/>,
  };

  return <div>
    {modal}
    <GridContainer>
      <GridItem xs={12} md={6}>
        <Card>
          <CardHeader color="primary">
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <h4 style={{flex: 1}}>Resumo</h4>
            </div>
          </CardHeader>
          <CardBody className={classes.resumo}>
            <table>
              <tr>
                <td>ID:</td>
                <td>{importacao.id}</td>
              </tr>
              <tr>
                <td>Utilizador:</td>
                <td>{general.Renderers.userRenderer({id: importacao.id_utilizador, nome: importacao.utilizador})}</td>
              </tr>
              <tr>
                <td>Data de Criação:</td>
                <td>{general.Renderers.dateRenderer(importacao.data_criacao)}</td>
              </tr>
              <tr>
                <td>Executado:</td>
                <td>{importacao.data_finalizacao ? <>Sim ({general.Renderers.dateRenderer(importacao.data_finalizacao, {hide_timezone: true})})</> : "-"}</td>
              </tr>
              <tr>
                <td>Cursos</td>
                <td>{importacao.ensaio.cursos.length}
                  <> ({importacao.ensaio.cursos.filter(c => c.resultado.codigo === "AVISO").length} com avisos,</>
                  <> {importacao.ensaio.cursos.filter(c => c.resultado.codigo === "ERRO").length} erros,</>
                  <> {importacao.ensaio.cursos.filter(c => c.resultado.codigo === "SALTAR").length} ignorados)</>
                </td>
              </tr>
              <tr>
                <td>Participações em cursos</td>
                <td>{importacao.ensaio.participacoes.length}
                  <> ({importacao.ensaio.participacoes.filter(c => c.resultado.codigo === "AVISO").length} com avisos,</>
                  <> {importacao.ensaio.participacoes.filter(c => c.resultado.codigo === "ERRO").length} erros,</>
                  <> {importacao.ensaio.participacoes.filter(c => c.resultado.codigo === "SALTAR").length} ignorados)</>
                </td>
              </tr>
              {importacao.ensaio.participantes_modulos && <tr>
                <td>Participações em módulos</td>
                <td>{importacao.ensaio.participantes_modulos.length}
                  <> ({importacao.ensaio.participantes_modulos.filter(c => c.resultado.codigo === "AVISO").length} com avisos,</>
                  <> {importacao.ensaio.participantes_modulos.filter(c => c.resultado.codigo === "ERRO").length} erros,</>
                  <> {importacao.ensaio.participantes_modulos.filter(c => c.resultado.codigo === "SALTAR").length} ignorados)</>
                </td>
              </tr>}

            </table>
            <div className={classes.acoes}>
              {!importacao.data_finalizacao && <Button className={classes.button + " " + classes.info + " " + classes.sm} size="sm" onClick={async () => {
                if (request.current) return;
                request.current = true;
                setSimulacaoAtiva(true);
                await connection.post("administracao/importacao_historico/" + importacao.id + "/simular", null, null, {returnError: true});
                connection.get('administracao/importacao_historico/' + importacao.id + "/detalhes").then(setImportacao)
                setSimulacaoAtiva(false);
                request.current = false;
              }}>Simular Novamente {simulacaoAtiva && <FontAwesomeIcon icon={faSpinner} spin color={"white"} style={{marginLeft: 10}}/>}</Button>}
              <Button className={classes.button + " " + classes.info + " " + classes.sm} size="sm" onClick={() => window.open(connection.getFullUrl('administracao/importacao_historico/' + importacao.id + '/exportar_erros'))}>Exportar Erros<FontAwesomeIcon icon={faFileExport} color={"white"} style={{marginLeft: 10}}/></Button>
              {!importacao.data_finalizacao && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={executar}>Executar Importação {execucaoAtiva && <FontAwesomeIcon icon={faSpinner} spin color={"white"} style={{marginLeft: 10}}/>}</Button>}
            </div>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12}>
        {!importacao.data_finalizacao ? tabelas_ensaio : <NavPills
          color="primary"
          alignCenter
          tabs={[
            {
              tabButton: "Resultado",
              tabIcon: DoneAll,
              tabContent: <Tabelas tipo={"resultado"}/>
            },
            {
              tabButton: "Simulação",
              tabIcon: Sort,
              tabContent: tabelas_ensaio
            }
          ]}
        />}
      </GridItem>
    </GridContainer>
  </div>;
}

function DetalhesImportacao({original: {resultado}, classes, confirmacoes}) {
  if (resultado.codigo === 'AVISO')
    return <div className={classes.subComponent}>
      {resultado.avisos.map((aviso, idx) => {
        let confirmacao = confirmacoes.current.includes(aviso.token_confirmacao);
        return <label key={idx} style={{display: "block", height: 35}}>
          <Checkbox
            defaultChecked={confirmacao}
            tabIndex={-1}
            onClick={() => {
              if (confirmacao)
                confirmacoes.current.splice(confirmacoes.current.indexOf(aviso.token_confirmacao), 1);
              else
                confirmacoes.current.push(aviso.token_confirmacao);
            }}
            checkedIcon={<Check className={classes.checkedIcon}/>}
            icon={<Check className={classes.uncheckedIcon}/>}
            classes={{
              checked: classes.checked
            }}
          />
          {aviso.mensagem}
          {aviso.id_modelo && <Link to={"/modelo/" + aviso.id_modelo} target={"_blank"}> <Tooltip title={"Ver modelo"} placement={"top"}><span><FontAwesomeIcon color={infoColor} icon={faEye}/></span></Tooltip></Link>}
        </label>
      })}
    </div>;
  return <div className={classes.subComponent}>
    <p>{resultado.mensagem}</p>
    {resultado.stack && <pre>{resultado.stack}</pre>}
  </div>;
}

export default withStyles(importacaoHistoricoStyle)(ImportacaoHistoricoDetalhe);
